import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DraftTourSnackBarComponent } from './draft-tour-snack-bar.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		DraftTourSnackBarComponent
	],
	exports: [
		DraftTourSnackBarComponent
	]
})
export class DraftTourSnackBarModule {}
